// extracted by mini-css-extract-plugin
export default {"formLayout":"formLayout_3Lw_e8mS","header":"header_2MS7ZDN6"};